var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"cookies"}},[_c('div',{attrs:{"id":"goBack"},on:{"click":function($event){$event.preventDefault();return _vm.goBack($event)}}},[_vm._v("←")]),_c('div',{attrs:{"id":"cookiesContainer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }